<script>
  // @ts-nocheck
  import { uiStore } from '$lib/stores/uiStore';

  export let form;

  let inputElem;

  uiStore.subscribe((uiStoreValues) => {
    setTimeout(() => {
      if (inputElem && uiStoreValues.isPasswordProtected) {
        inputElem.focus();
      }
    }, 500);
  });
</script>

{#if $uiStore.isPasswordProtected}
  <div class="modal w-full h-screen fixed top-0 left-0 flex items-start lg:items-center justify-center p-5 bg-gray-700/30 z-50 backdrop-blur-sm">
    <div class="bg-white w-full rounded-lg shadow-md max-w-lg">
      <form method="POST" action="?/submitPassword">
        <div class="border-b border-slate-100 px-4 py-4">
          <h4 class="text-sm font-medium text-gray-900 mb-1">Secure access</h4>
          <p class="text-xs text-gray-900">Please enter password to use this app</p>
        </div>
        <div class="p-4 max-h-[75vh] overflow-y-auto">
          <div>
            <label for="password" class="block text-sm font-medium leading-6 text-gray-900">Password</label>
            <div class="relative mt-2 rounded-md shadow-sm">
              <input class:error={form?.password?.message} type="password" name="password" id="password" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" placeholder="Enter password of this app"  aria-invalid="true" aria-describedby="password">
              {#if form?.password?.message}
                <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
                  <svg class="h-5 w-5 text-red-500" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd" />
                  </svg>
                </div>
              {/if}
            </div>
            {#if form?.password?.message}
              <p class="mt-2 text-sm text-red-600" id="password-error">{form?.password?.message}</p>
            {/if}
          </div>
        </div>
        <div class="p-4 border-t border-slate-100 flex justify-end">
          <button type="submit" class="rounded bg-indigo-600 px-2 py-1 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
            Enter
          </button>
        </div>
      </form>
    </div>
  </div>
{/if}

<style lang="postcss">
  .error {
    @apply ring-red-300 placeholder:text-red-300  text-red-900 focus:ring-red-500;
  }
</style>
